import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { Typography } from '@cp/ds/src/components/typography';
import { TranslationGroup } from '@common/model/resource/translationGroup';
import { TranslationMnemonic } from '@common/model/resource/translationMnemonic';
import { SxProps, styled } from '@cp/ds';
import { RubOutlineIcon } from '@cp/ds/src/icons';
import { useTranslations } from 'src/shared/translation';

const Root = styled(Stack)(({ theme }) => ({
  paddingInline: '4px',
  borderRadius: '26px',
  height: '24px',
  border: `1px solid ${theme.palette['gray middle']}`,
  backgroundColor: theme.palette['brand gray'],
  [theme.breakpoints.up('md')]: {
    border: `1px solid ${theme.palette['white']}`,
    paddingLeft: '4px',
    paddingRight: '5px',
  },
}));

const StyledIcon = styled(Stack)(({ theme }) => ({
  width: '12px',
  height: '12px',
  backgroundColor: theme.palette['white'],
  borderRadius: '50%',
  [theme.breakpoints.up('md')]: {
    width: '15px',
    height: '15px',
  },
}));

const StyledPrice = styled(Typography)(({ theme }) => ({
  fontSize: '11px',
  color: theme.palette['white'],
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
  },
}));

const StyledPriceText = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '10px',
  color: theme.palette['gray middle'],
  [theme.breakpoints.up('md')]: {
    fontSize: '11px',
  },
}));

export const CatalogItemPrice: React.FC<{ data: CatalogItemViewModel; sx?: SxProps }> = ({ data, sx }) => {
  const [getCatalogTranslation] = useTranslations(TranslationGroup.Catalog);

  const priceValue =
    data.tariffs?.reduce((acc, t) => (acc && acc?.childrenCount < t.childrenCount ? acc : t), data.tariffs?.[0])?.price ?? data.price;

  const price = typeof priceValue === 'number' ? priceValue : getCatalogTranslation(TranslationMnemonic.CatalogItemPriceNotSetLabel);

  return (
    <Root alignItems="center" direction="row" gap={'4px'} sx={{ ...sx }}>
      <StyledIcon alignItems="center" justifyContent="center">
        <RubOutlineIcon
          sx={{
            fontSize: { xs: '11px', md: '14px' },
            color: 'brand gray',
          }}
        />
      </StyledIcon>
      <StyledPrice component="span" variant="small text bold">
        {price}
      </StyledPrice>
      <StyledPriceText component="span" variant="extraSmall">
        {' '}
        р/час
      </StyledPriceText>
    </Root>
  );
};
